export default "__VITE_ASSET__BGaei2yx__"